import React from 'react';
import { BOARD_LAYOUT } from '../../lib/utils';
import { BoardSquare } from './BoardSquare';
import { BoardState, PlayerId } from '../../lib/game-logic';
interface BoardProps {
  boardState: BoardState;
  lastMoveProduct?: number;
  highlightProducts?: number[];
  onSquareClick: (product: number) => void;
  disabled?: boolean;
}
export function Board({
  boardState,
  lastMoveProduct,
  highlightProducts = [],
  onSquareClick,
  disabled
}: BoardProps) {
  return <div className="grid grid-cols-6 gap-1.5 p-3 bg-white rounded-2xl shadow-xl border border-slate-100 w-full max-w-[calc(100vw-40px)] aspect-square mx-auto" data-id="element-76">
      {BOARD_LAYOUT.map((row, rIndex) => row.map((product, cIndex) => <BoardSquare key={`${rIndex}-${cIndex}`} product={product} owner={boardState[product]} isHighlight={highlightProducts.includes(product)} isLastMove={lastMoveProduct === product} onClick={() => onSquareClick(product)} disabled={disabled} data-id="element-77" />))}
    </div>;
}